<div class="container-fluid plan-detail-container plan-details-{{gridContext.viewMode?.toLowerCase()}}"  *ngIf="!_isNestedRoute">
  <div class="row" class="d-none">
    <div class="col">
      Start date:<span class="text-success">{{'01/02/2015' | date:'full'}}</span> -
      End date:<span class="text-success">{{'01/02/2015' | date:'full'}}</span>
    </div>
  </div>
  <div class="row" style="margin-top: 13px">
    <div class="col">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a routerLink="/plans">
            {{"plan.page.title" | translate}}
          </a>
          <svg style="width: 14px;height: 14px;margin-left: 3px; fill:#212529">
            <use xlink:href="#icon-arrow-right" />
          </svg>
        </li>
      </ol>
    </div>
  </div>
  <div class="row mb-2 page-title-container">
    <div class="col page-header plan-detail">
      <wfm-page-title title="{{planName}}"></wfm-page-title>
    </div>
    <div class="col text-right">
      <button id="mu-dist" [ngClass]="{'disabled': _isMUDirty || isManualEditing}" class="btn btn-secondary btn-lg " (click)="navigateToDistribution()" [disabled]="UnappliedChanges || isManualEditing" title="{{'plan.detail.mu.dist.btn'|translate}}">{{"plan.detail.mu.dist.btn"|translate}}</button>
      <div class="d-inline-block" ngbDropdown #myDrop="ngbDropdown">
          <div ngbDropdown class="d-inline-block">
              <button class="btn btn-secondary"  [ngClass]="{'disabled': _isLoading || isManualEditing}" [disabled]="_isLoading || isGridInvalid || isManualEditing" id="dropdownSettings" ngbDropdownToggle title="{{'plan.options'|translate}}" tooltipPosition="left">
                <svg style="width: 16px;height: 16px; fill: #777f85">
                    <use xlink:href="#icon-more" />
                </svg>
              </button>

              <div ngbDropdownMenu aria-labelledby="dropdownSettings">
                <button *ngIf="tenantService.isCXOne===false" ngbDropdownItem class="dropdown-item" (click)="showConvertToActiveDialog()" [disabled]="!_userHasModify || UnappliedChanges" id="btn-convert">
                  <i class="icon icon-status_assigned" aria-hidden="true"></i>
                   {{"plan.convert.active"|translate}}
                </button>

                <div class="dropdown-divider"></div>

                <button ngbDropdownItem class="dropdown-item" [disabled]="isDisableExportAsCsv()" (click)="onBtnExport()" id="btn-export" title='{{"plan.exportcsv"|translate}}'>
                  <i class="icon icon-CSV" aria-hidden="true"></i> {{"plan.exportcsv"|translate}}
                </button>

                <button ngbDropdownItem class="dropdown-item" [disabled]="isDisableExportEveryCt()" (click)="onBtnExportEveryCt()" id="btn-exporteveryct">
                  <i class="icon icon-data-download" aria-hidden="true"></i> {{"plan.exporteveryctcsv"|translate}}
                </button>

                <ng-container *ngIf="_planSyncFeature">
                  <div class="dropdown-divider"></div>

                  <button ngbDropdownItem class="dropdown-item" [disabled]="isDisableExportExcel()" (click)="onBtnExportExcel()" id="btn-export-excel" title='{{"plan.exportexcel"|translate}}'>
                    <i class="icon icon-office-excel" aria-hidden="true"></i> {{"plan.exportexcel"|translate}}
                  </button>

                  <button ngbDropdownItem class="dropdown-item" [disabled]="isDisableImportExcel()" (click)="onBtnImportExcel()" id="btn-import-excel" title='{{"plan.importexcel"|translate}}'>
                    <i class="icon icon-office-excel" aria-hidden="true"></i> {{"plan.importexcel"|translate}}
                  </button>
                </ng-container>

                <div class="dropdown-divider"></div>

                <button ngbDropdownItem class="dropdown-item" [disabled]="UnappliedChanges" (click)="navigateToPlanCtSettings()" id="btn-plan-ct-settings" title='{{"plan.ct.settings.page.title"|translate}}'>
                  <i class="icon icon-Icons_svg_skills" aria-hidden="true"></i> {{"plan.ct.settings.page.title"|translate}}
                </button>
<!--
                <button *ngIf="_ctDistMethodFeature" class="dropdown-item" (click)="showPlanSettingsDialog()" id="btn-settings">
                  <svg style="width: 20px;height: 20px;">
                    <use xlink:href="#icon-setup" />
                  </svg> {{"plan.settings"|translate}}
                </button>
-->

         <!--       <button *ngIf="_ctDistMethodFeature==false" class="dropdown-item" (click)="showSettings()" id="btn-settings2" title='{{"plan.settings"|translate}}'>
                    <svg style="width: 20px;height: 20px;">
                        <use xlink:href="#icon-setup" />
                    </svg> {{"plan.settings"|translate}}
                </button>-->
                <button ngbDropdownItem class="dropdown-item"
                        [disabled]="UnappliedChanges"
                        (click)="showPlanSettingsDialog()" id="btn-settings3">
                  <i class="icon icon-Icons_svg_setup" aria-hidden="true"></i> {{getPlanSettingsText()}}
                </button>

                <button *ngIf="_newHireSettingsFeature" ngbDropdownItem [disabled]="UnappliedChanges" class="dropdown-item" (click)="navigateToNewHireSettings()" id="btn-nhtp-settings">
                  <i class="icon icon-Headphones" aria-hidden="true"></i> {{"new.hire.page.title" | translate}}
                </button>
                <ng-container *ngIf="_externalForecastFeature">
                  <div class="dropdown-divider"></div>
                  <button [disabled]="UnappliedChanges" class="dropdown-item" (click)="navigateToExternalForecast()" id="btn-plan-external-forecast" title='{{"external.forecast.menu" | translate}}'>
                    <i class="icon icon-Icons_svg_import-forecast-data"></i> {{"external.forecast.menu" | translate}}
                  </button>
                </ng-container>

              </div>
          </div>
      </div>

      <button *ngIf="_userHasModify" id="save-as-btn" [ngClass]="{'disabled':UnappliedChanges || isManualEditing}" class="btn btn-secondary btn-lg  no-right-margin" [disabled]="UnappliedChanges || isGridInvalid || isManualEditing" (click)="showSaveAsDlg()" title='{{"plan.save.as.btn"|translate}}'>{{"plan.save.as.btn"|translate}}</button>
      <button *ngIf="_userHasModify" id="save-btn" [ngClass]="{'disabled': _dataIsSaved || UnappliedChanges || isManualEditing}" class="btn btn-primary btn-lg no-right-margin" [disabled]=" _dataIsSaved || UnappliedChanges || isGridInvalid || isManualEditing" (click)="saveButtonClicked()" title='{{"plan.save"|translate}}'>{{"plan.save"|translate}}</button>


      <breeze-button class="d-none" buttonText="Close" id="btn-cancel-plan" [isPrimary]="true" btnSizeClass="btn-lg no-right-margin">
      </breeze-button>

    </div>
  </div>
  <div class="row toolbar-container text-left no-gutters">
    <div class="toolbar-items-left ctmu-container">
      <div class="btn-group">
        <button id="ct-btn" class="btn btn-secondary btn-rect btn-small float-right" title="{{'plan.details.ct.view.label' | translate}}"
          [ngClass]="{'active':isMUView==false}" (click)="setEntityView('CT')"
          [disabled]="_isLoading || isGridInvalid || disableEntityViewToggle">
          <i class="icon-Icons_svg_skills"></i>
        </button>
        <button id="mu-btn" class="btn btn-secondary btn-rect btn-small float-right" title="{{'plan.details.mu.view.label' | translate}}"
          [ngClass]="{'active':isCTView==false}" (click)="setEntityView('MU')"
          [disabled]="_isLoading || isGridInvalid || disableEntityViewToggle">
            <i class="icon-Icons_svg_schedulin-unit"></i>
        </button>
      </div>
      <!--<span *ngIf="selectedContactType" class="toolbar-label">{{"muct.dropdown.label"|translate}}</span>-->
<!--      <wfm-select *ngIf="selectedContactType" #muctSelector
                  class="contactTypeDropDown toolbar-select"
                  selectName="contactType"
                  selectId="contactType"
                  [items]="contactTypeList"
                  [disabled]="_isLoading || isGridInvalid"
                  (wfmSelectEvent)="updateContactType($event)"
                  [selectedItem]="selectedContactType">
      </wfm-select>-->
      <p-multiselect placeholder=" " #ctSelector
                     *ngIf="isCTView"
                     [ariaLabel]="'plan.details.cts.all' | translate"
                     (click)="onMultiselectContainerClick($event, ctSelector)"
                     class="filterable ct-selector contactTypeDropDown toolbar-select no-x-scroll"
                     [(ngModel)]="selectedCTs"
                     ngDefaultControl
                     [options]="contactTypeList"
                     [showToggleAll]="false"
                     [virtualScroll]="true"
                     scrollHeight="200px"
                     appendTo="body"
                     panelStyleClass="esp-multiselect-fixed-height ct-single-select-overlay"
                     optionLabel="value.label"
                     optionValue="value"
                     [virtualScrollItemSize]="40"
                     (onChange)="updateSelectedCTs($event)"
                     (onPanelShow)="onCtPanelShow()"
                     (onPanelHide)="onCtPanelHide()"
                     [showHeader]="true"
                     [filter]="false"
                     [disabled]="_isLoading || isGridInvalid"
                     emptyFilterMessage="{{'plan.details.dropdown.contact.types.empty' | translate}}"
                     styleClass="fullrow">
        <ng-template let-value pTemplate="selectedItems">
          <!--<ng-container
            *ngTemplateOutlet="multiSelectSelectedItems;
            context: { value: value, emptyMessage: 'historical-data.ct.empty.selection' }">
          </ng-container>-->
          <esp-multi-select-content [items]="value" emptyMessage="plan.details.dropdown.contact.types.empty.selection"> </esp-multi-select-content>
        </ng-template>
        <ng-template pTemplate="header">
          <esp-multi-select-filter [multiSelect]="ctSelector" [displaySelectOptions]=false
            [searchAriaLabel]="'multi.select.filter.search.contact.types' | translate">

          </esp-multi-select-filter>
        </ng-template>
        <ng-template pTemplate="footer">
          <esp-multi-select-footer [multiSelect]="ctSelector">

          </esp-multi-select-footer>
        </ng-template>
        <ng-template let-item pTemplate="item">
          <!--<ng-container *ngTemplateOutlet="multiSelectItem; context:  { $implicit: item }"></ng-container>-->
          <esp-single-select-item [item]="item"></esp-single-select-item>
        </ng-template>
      </p-multiselect>
      <p-multiselect placeholder=" " #muSelector
                     *ngIf="isMUView"
                     [ariaLabel]="'plan.details.dropdown.management.units' | translate"
                     (click)="onMultiselectContainerClick($event, muSelector)"
                     class="filterable mu-selector contactTypeDropDown toolbar-select no-x-scroll"
                     [(ngModel)]="selectedMUs"
                     ngDefaultControl
                     [options]="managementUnitsList"
                     [showToggleAll]="false"
                     [virtualScroll]="true"
                     scrollHeight="200px"
                     appendTo="body"
                     panelStyleClass="esp-multiselect-fixed-height"
                     optionLabel="value.label"
                     optionValue="value"
                     [virtualScrollItemSize]="40"
                     (onChange)="updateSelectedMUs($event)"
                     (onPanelHide)="muSelectorClosed()"
                     [showHeader]="true"
                     [filter]="false"
                     [disabled]="!_isGridValid || _isLoading"
                     emptyFilterMessage="{{'plan.details.dropdown.management.units.empty' | translate}}"
                     styleClass="fullrow">
        <ng-template let-value pTemplate="selectedItems">

            <!--<ng-container
              *ngTemplateOutlet="multiSelectSelectedItems;
              context: { value : value, emptyMessage:'historical-data.params.empty.selection' }">
            </ng-container>-->
            <esp-multi-select-content [items]="value" emptyMessage="plan.details.dropdown.management.units.empty.selection"> </esp-multi-select-content>

        </ng-template>
        <ng-template pTemplate="header">
          <esp-multi-select-filter [multiSelect]="muSelector"
            [searchAriaLabel]="'multi.select.filter.search.management.units' | translate">

          </esp-multi-select-filter>
        </ng-template>
        <ng-template pTemplate="footer">
          <esp-multi-select-footer [multiSelect]="muSelector">

          </esp-multi-select-footer>
        </ng-template>
        <ng-template let-item pTemplate="item">
          <esp-multi-select-item [item]="item"></esp-multi-select-item>
        </ng-template>
      </p-multiselect>
      <!--
        Stable aria-controls targets for the CT/MU comboboxes. They are NOT given
        role="listbox": an empty listbox in the accessibility tree is announced as
        "list box, 0 items". aria-controls only needs a valid IDREF to an existing
        element, so these stay as inert, visually hidden, role-less containers that
        screen readers ignore while still satisfying the combobox's aria-controls.
      -->
      <div id="ctSelector_list" class="sr-only"></div>
      <div id="muSelector_list" class="sr-only"></div>
    </div>
    <div class="toolbar-items-center">
      <validation-navigator [gridApi]="gridApi" [gridContext]="gridContext" [invalidCount]="_invalidCells.size" *ngIf="_invalidCells.size>0"></validation-navigator>
      <ng-template #undoButtonCtx>
        <div class="message-undo">
          <p>{{"plan.undo.paste.msg" | translate }} </p>
        </div>
        <div class="button-response">
          <breeze-button [isSecondary]="true" [showTooltip] = "false" buttonText="{{'plan.cancel.btn' | translate }}"></breeze-button>
          <breeze-button [isPrimary]="true" [showTooltip] = "false" buttonText="{{'btn.reset.label' | translate }}" (clicked)="discard()"></breeze-button>
        </div>
      </ng-template>
      <button *ngIf="isGridInvalid"
              [ngClass]="{'disabled': _isLoading}"
              class="btn btn-secondary btn-rect btn-discard"
              title="{{'plan.undo.btn' | translate}}"
              [disabled]="_isLoading"
              container="body"
              [ngbPopover]="undoButtonCtx"
              placement="bottom">
        <i class="icon icon-undo"></i>
      </button>
    </div>
    <div class="toolbar-items-right text-right">
      <breeze-button buttonText="{{'plan.apply.btn'|translate}}" *ngIf="isMUgrid"
                     id="apply-mu-edits"
                     [isPrimary]="true"
                     [isDisabled]="isMUApplyDisabled || isGridInvalid || isManualEditing"
                     (clicked)="applyMUEdits()">
      </breeze-button>
      <breeze-button buttonText="{{'plan.apply.btn'|translate}}" *ngIf="!isMUgrid && CTDistMode=='FTE_REQUIRED'"
                     id="apply-distributions"
                     [isPrimary]="true"
                     [isDisabled]="!_isFTERequiredDirty || isGridInvalid || isManualEditing"
                     (clicked)="applyFTERequired()">
      </breeze-button>
        <button  *ngIf="multiStepWorkflow"
                  [ngClass]="{'disabled': _isLoading}"
                  class="btn btn-secondary btn-rect btn-small"
                  title="{{'multistep.workflow.button' | translate}}"
                  [disabled]="_isLoading || isGridInvalid"
                  (click)="showMswfRulesDlg()" >
          <i class="icon icon-workflow"></i>
        </button>
      <div class="btn-group">
        <button  class="btn btn-secondary btn-rect btn-small float-right" title="{{'chart.btn.grid.view' | translate}}" [attr.aria-label]="'chart.btn.grid.view' | translate" [ngClass]="{'active':isChartView==false}" (click)="toggleChartButtonClicked(0)" [disabled]="isGridInvalid">
          <svg style="width: 16px;height: 16px; fill: #777f85" id="icon-Horizontal-View" viewBox="0 0 20 20" width="100%" height="100%" aria-hidden="true" focusable="false">
            <path d="M0 6h20v14h-20v-14zM2 8v4h4v-4h-4zM20 4v-4h-20v4h20zM18 12v-4h-4v4h4zM12 12v-4h-4v4h4zM18 18v-4h-4v4h4zM12 18v-4h-4v4h4zM6 18v-4h-4v4h4z"></path>
          </svg>
        </button>
        <button class="btn btn-secondary btn-rect btn-small float-right" title="{{'chart.btn.chart.1.view' | translate}}" [attr.aria-label]="'chart.btn.chart.1.view' | translate" [ngClass]="{'active':isChartView && chartsCount==1}" (click)="toggleChartButtonClicked(1)" [disabled]="isGridInvalid">
          <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <!-- Generator: Sketch 61 (89581) - https://sketch.com -->
            <desc>Created with Sketch.</desc>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="temp" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(-180.000000) translate(-10.000000, -10.000000) translate(0.000000, -0.000000)" fill="#777F8B" fill-rule="nonzero">
                <path d="M19.1592178,19.9876321 L0.840782241,19.9876321 C0.341183932,19.9876321 0.00811839323,19.6545666 0.00811839323,19.1549683 L0.00811839323,1.66919662 C0.00811839323,0.753276956 0.757505285,0.00389006342 1.67342495,0.00389006342 L18.3265328,0.00389006342 C19.2424524,0.00389006342 19.9918393,0.753276956 19.9918393,1.66919662 L19.9918393,19.1549683 C19.9918393,19.6545666 19.6587738,19.9876321 19.1591755,19.9876321 L19.1592178,19.9876321 Z M18.3265539,1.66921776 L1.67344609,1.66921776 L1.67344609,18.3223256 L18.3265539,18.3223256 L18.3265539,1.66921776 Z M5.0040592,4.16718816 C5.42038055,4.16718816 5.83672304,4.58350951 5.83672304,4.99985201 L5.83672304,8.33046512 C5.83672304,8.74678647 5.42040169,9.16312896 5.0040592,9.16312896 C4.5877167,9.16312896 4.17139535,8.74680761 4.17139535,8.33046512 L4.17139535,4.99985201 C4.17139535,4.58353066 4.5877167,4.16718816 5.0040592,4.16718816 Z M8.33469345,4.16718816 C8.7510148,4.16718816 9.16735729,4.58350951 9.16735729,4.99985201 L9.16735729,13.3264059 C9.16735729,13.7427273 8.75103594,14.1590698 8.33469345,14.1590698 C7.91835095,14.1590698 7.5020296,13.7427484 7.5020296,13.3264059 L7.5020296,4.99985201 C7.5020296,4.58353066 7.91835095,4.16718816 8.33469345,4.16718816 Z M11.6653066,4.16718816 C12.0816279,4.16718816 12.4979704,4.58350951 12.4979704,4.99985201 L12.4979704,11.6610994 C12.4979704,12.0774207 12.081649,12.4937632 11.6653066,12.4937632 C11.2489641,12.4937632 10.8326427,12.0774419 10.8326427,11.6610994 L10.8326427,4.99985201 C10.8326427,4.58353066 11.2489641,4.16718816 11.6653066,4.16718816 Z M14.9959408,4.16718816 C15.4122622,4.16718816 15.8286047,4.58350951 15.8286047,4.99985201 L15.8286047,14.9917125 C15.8286047,15.4080338 15.4122833,15.8243763 14.9959408,15.8243763 C14.5795983,15.8243763 14.163277,15.408055 14.163277,14.9917125 L14.163277,4.99985201 C14.163277,4.58353066 14.5795983,4.16718816 14.9959408,4.16718816 Z" id="Shape"></path>
              </g>
            </g>
          </svg>
        </button>
        <button class="btn btn-secondary btn-rect btn-small float-right" title="{{'chart.btn.chart.2.view' | translate}}" [attr.aria-label]="'chart.btn.chart.2.view' | translate" [ngClass]="{'active':isChartView && chartsCount==2}" (click)="toggleChartButtonClicked(2)" [disabled]="isGridInvalid">
          <svg width="21px" height="21px" viewBox="0 0 21 21" version="1.1" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Group-2" transform="translate(0.000000, -2.000000)" fill="#777F8B" fill-rule="nonzero">
                <path d="M12.9991184,3.012 L12.9991184,4.677 L1.67344609,4.67767442 L1.67344609,21.3307822 L18.3265539,21.3307822 L18.3261184,11 L19.9911184,11 L19.9918393,21.3308034 C19.9918393,22.1985167 19.3192594,22.9167658 18.4696828,22.9899673 L18.3265328,22.9961099 L1.67342495,22.9961099 C0.757505285,22.9961099 0.00811839323,22.246723 0.00811839323,21.3308034 L0.00811839323,21.3308034 L0.00811839323,3.84503171 C0.00811839323,3.3454334 0.341183932,3.01236786 0.840782241,3.01236786 L0.840782241,3.01236786 L12.9991184,3.012 Z M5.0040592,13.836871 C5.42040169,13.836871 5.83672304,14.2532135 5.83672304,14.6695349 L5.83672304,14.6695349 L5.83672304,18.000148 C5.83672304,18.4164905 5.42038055,18.8328118 5.0040592,18.8328118 C4.5877167,18.8328118 4.17139535,18.4164693 4.17139535,18.000148 L4.17139535,18.000148 L4.17139535,14.6695349 C4.17139535,14.2531924 4.5877167,13.836871 5.0040592,13.836871 Z M8.33469345,8.84093023 C8.75103594,8.84093023 9.16735729,9.25727273 9.16735729,9.67359408 L9.16735729,9.67359408 L9.16735729,18.000148 C9.16735729,18.4164905 8.7510148,18.8328118 8.33469345,18.8328118 C7.91835095,18.8328118 7.5020296,18.4164693 7.5020296,18.000148 L7.5020296,18.000148 L7.5020296,9.67359408 C7.5020296,9.25725159 7.91835095,8.84093023 8.33469345,8.84093023 Z M11.6653066,10.5062368 C12.081649,10.5062368 12.4979704,10.9225793 12.4979704,11.3389006 L12.4979704,11.3389006 L12.4979704,18.000148 C12.4979704,18.4164905 12.0816279,18.8328118 11.6653066,18.8328118 C11.2489641,18.8328118 10.8326427,18.4164693 10.8326427,18.000148 L10.8326427,18.000148 L10.8326427,11.3389006 C10.8326427,10.9225581 11.2489641,10.5062368 11.6653066,10.5062368 Z M15.8281184,11 L15.8286047,18.000148 C15.8286047,18.4164905 15.4122622,18.8328118 14.9959408,18.8328118 C14.5795983,18.8328118 14.163277,18.4164693 14.163277,18.000148 L14.163277,18.000148 L14.1631184,11 L15.8281184,11 Z" id="Combined-Shape"></path>
                <path d="M20.558,9 L20.558,7.812 L17.849,7.812 L19.298,6.444 C19.712,6.06 19.991,5.718 20.135,5.418 C20.279,5.118 20.351,4.797 20.351,4.455 C20.351,4.077 20.2535,3.7485 20.0585,3.4695 C19.8635,3.1905 19.5905,2.9745 19.2395,2.8215 C18.8885,2.6685 18.479,2.592 18.011,2.592 C17.453,2.592 16.958,2.6955 16.526,2.9025 C16.094,3.1095 15.755,3.396 15.509,3.762 L15.509,3.762 L16.571,4.446 C16.721,4.236 16.907,4.0785 17.129,3.9735 C17.351,3.8685 17.6,3.816 17.876,3.816 C18.206,3.816 18.4565,3.8835 18.6275,4.0185 C18.7985,4.1535 18.884,4.347 18.884,4.599 C18.884,4.773 18.839,4.9485 18.749,5.1255 C18.659,5.3025 18.485,5.514 18.227,5.76 L18.227,5.76 L15.797,8.055 L15.797,9 L20.558,9 Z" id="2"></path>
              </g>
            </g>
          </svg>
        </button>
        <button class="btn btn-secondary btn-rect btn-small float-right" title="{{'chart.btn.chart.4.view' | translate}}" [attr.aria-label]="'chart.btn.chart.4.view' | translate" [ngClass]="{'active':isChartView && chartsCount==4}" (click)="toggleChartButtonClicked(4)" [disabled]="isGridInvalid">
          <svg width="22px" height="21px" viewBox="0 0 22 21" version="1.1" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Group" fill="#777F8B" fill-rule="nonzero">
                <path d="M12.9991184,1.012 L12.9991184,2.677 L1.67344609,2.67767442 L1.67344609,19.3307822 L18.3265539,19.3307822 L18.3261184,9 L19.9911184,9 L19.9918393,19.3308034 C19.9918393,20.1985167 19.3192594,20.9167658 18.4696828,20.9899673 L18.3265328,20.9961099 L1.67342495,20.9961099 C0.757505285,20.9961099 0.00811839323,20.246723 0.00811839323,19.3308034 L0.00811839323,19.3308034 L0.00811839323,1.84503171 C0.00811839323,1.3454334 0.341183932,1.01236786 0.840782241,1.01236786 L0.840782241,1.01236786 L12.9991184,1.012 Z M5.0040592,11.836871 C5.42040169,11.836871 5.83672304,12.2532135 5.83672304,12.6695349 L5.83672304,12.6695349 L5.83672304,16.000148 C5.83672304,16.4164905 5.42038055,16.8328118 5.0040592,16.8328118 C4.5877167,16.8328118 4.17139535,16.4164693 4.17139535,16.000148 L4.17139535,16.000148 L4.17139535,12.6695349 C4.17139535,12.2531924 4.5877167,11.836871 5.0040592,11.836871 Z M8.33469345,6.84093023 C8.75103594,6.84093023 9.16735729,7.25727273 9.16735729,7.67359408 L9.16735729,7.67359408 L9.16735729,16.000148 C9.16735729,16.4164905 8.7510148,16.8328118 8.33469345,16.8328118 C7.91835095,16.8328118 7.5020296,16.4164693 7.5020296,16.000148 L7.5020296,16.000148 L7.5020296,7.67359408 C7.5020296,7.25725159 7.91835095,6.84093023 8.33469345,6.84093023 Z M11.6653066,8.50623679 C12.081649,8.50623679 12.4979704,8.92257928 12.4979704,9.33890063 L12.4979704,9.33890063 L12.4979704,16.000148 C12.4979704,16.4164905 12.0816279,16.8328118 11.6653066,16.8328118 C11.2489641,16.8328118 10.8326427,16.4164693 10.8326427,16.000148 L10.8326427,16.000148 L10.8326427,9.33890063 C10.8326427,8.92255814 11.2489641,8.50623679 11.6653066,8.50623679 Z M15.8281184,9 L15.8286047,16.000148 C15.8286047,16.4164905 15.4122622,16.8328118 14.9959408,16.8328118 C14.5795983,16.8328118 14.163277,16.4164693 14.163277,16.000148 L14.163277,16.000148 L14.1631184,9 L15.8281184,9 Z" id="Combined-Shape"></path>
                <polygon id="4" points="20.594 7 20.594 5.677 21.62 5.677 21.62 4.489 20.594 4.489 20.594 3.31 19.217 3.31 19.217 4.489 17.525 4.489 20.279 0.7 18.749 0.7 15.779 4.696 15.779 5.677 19.172 5.677 19.172 7"></polygon>
              </g>
            </g>
          </svg>
        </button>
      </div>
    </div>

  </div>
  <div class="row slider" [ngClass]="{'alternate':isChartView==true}">
    <!-- a11y (WCAG 2.4.3 Focus Order): both slides stay in the DOM and the
         inactive one is only translated off-screen, so its focusable content
         (AG Grid tab guards / scroll-region tab stop, or the chart's tabindex=0
         plot area) would otherwise stay in the tab order and swallow Tab focus
         while invisible. `inert` removes the off-screen slide from the tab order
         AND the accessibility tree, so Tab moves straight from the toolbar into
         whichever view is actually shown. -->
    <div class="col slide" style="" [ngClass]="{'active':isChartView==false}" [attr.inert]="isChartView ? '' : null">
      <div class="table-list editable-grid multi-cell-edit plan-detail-grid">

        <!-- A11y (WCAG 1.3.1 / 4.1.2): `ensureDomOrder` keeps the rendered cells
             in visual (left-to-right) order so a screen reader reads columns in
             the correct sequence. It is cheap and stays enabled for the CT view.
             `suppressColumnVirtualisation` is deliberately NOT set: forcing every
             column into the DOM (wide Weekly/Daily CT grids can have 50-365
             columns) rendered all columns for all rows and froze the grid /
             blanked the pinned Parameter column on scroll. Column virtualization
             is therefore left ON for performance; AG Grid's own keyboard
             navigation still scrolls off-screen cells into view, so keyboard
             users are not blocked (only the JAWS virtual-cursor sweep across
             not-yet-rendered columns degrades). -->
        <ag-grid-angular class="ag-theme-balham" [rowData]="rowData" #grid
                         [ngClass]="{'data-rendering':isRenderingData,'data-rendered':!isRenderingData,'rollup-collapsed':_isRollupCollapsed}"
                         [rowHeight]="36"
                         [headerHeight]="39"
                         [context]="gridContext"
                         [columnDefs]="colDefs"
                         [gridOptions]="gridOptions"
                         [stopEditingWhenCellsLoseFocus]="true"
                         [components]="frameworkComponents"
                         [suppressPreventDefaultOnMouseWheel]="true"
                         [loadingOverlayComponent]="loadingOverlayComponent"
                         [suppressScrollOnNewData]="true"
                         [debug]="false"
                         [modules]="modules"
                         [ensureDomOrder]="isCTView"
                         [excelStyles]="excelStyles"
                         enableRangeSelection="true"
                         enableFillHandle="true"
                         rowSelection="multiple"
                         suppressCopyRowsToClipboard="true"
                         [suppressLoadingOverlay]="suppressLoadingOverlay"
                         [enableBrowserTooltips]="true"
                         [animateRows]="false"
                         (newColumnsLoaded)="onGridColumnsChanged($event)"
                         [rowClassRules]="rowClassRules"
                         [defaultColDef]="defaultColDef"
                         (cellEditingStarted)="onCellEditingStarted()"
                         (cellEditingStopped)="onCellEditingStopped()"
                         [groupRowRenderer]="groupRowRenderer"
                         [groupRowRendererParams]="groupRowRendererParams"
                         (rowGroupOpened) = "rowGroupOpened($event)"
                         [isGroupOpenByDefault]="isGroupOpenByDefault"
                         [pinnedTopRowData]="topRowsData"
                         [frozenScroll]="gridApi"
                         [noRowsOverlayComponent]="'noRowsOverlay'"
                         [noRowsOverlayComponentParams]="noRowsComponentParams"
                         (gridReady)="onGridReady($event)">
        </ag-grid-angular>

      </div>
    </div>
    <div class="col slide" [ngClass]="{'active' : isChartView==true}" [attr.inert]="isChartView ? null : ''">

      <plan-multi-chart *ngIf="chartsCount==1 && hasRows" [chartsCount]="1" [contactType]="currentEntityView" [isVisible]="isChartView" [rowData]="allRowsData" [columnDefs]="colDefs" [viewMode]="gridContext.viewMode" [gridContext]="gridContext" [isLoading]="_isLoading" (drillDown)="updateViewMode(false)" (rollUp)="updateViewMode(true)" [locale]="locale"></plan-multi-chart>
      <plan-multi-chart *ngIf="chartsCount==2 && hasRows" [chartsCount]="2" [contactType]="currentEntityView" [isVisible]="isChartView" [rowData]="allRowsData" [columnDefs]="colDefs" [viewMode]="gridContext.viewMode" [gridContext]="gridContext" [isLoading]="_isLoading" (drillDown)="updateViewMode(false)" (rollUp)="updateViewMode(true)" [locale]="locale"></plan-multi-chart>
      <plan-multi-chart *ngIf="chartsCount==4 && hasRows" [chartsCount]="4" [contactType]="currentEntityView" [isVisible]="isChartView" [rowData]="allRowsData" [columnDefs]="colDefs" [viewMode]="gridContext.viewMode" [gridContext]="gridContext" [isLoading]="_isLoading" (drillDown)="updateViewMode(false)" (rollUp)="updateViewMode(true)" [locale]="locale"></plan-multi-chart>

      <wfm-esp-no-rows-overlay *ngIf="isChartView && hasRows==false" [params]="noRowsComponentParams">

      </wfm-esp-no-rows-overlay>
    </div>
  </div>
  <wfm-task-progress [task]="task" *ngIf="task">

  </wfm-task-progress>
</div>

<!-- Hidden file input for Excel import -->
<input type="file" #fileInput (change)="onFileSelected($event)" accept=".xlsx" style="display: none;">

<div class="dialog-container"></div>
<p-toast position="bottom-right" [baseZIndex]="1060">
</p-toast>
<svg width="10" height="10">
  <symbol id="icon-arrow-right" viewBox="5 0 30 30">
    <path d="M15 8.8l-8.5-8.5c-0.4-0.4-1.1-0.4-1.5 0s-0.4 1.1 0 1.5l8 8-8 8.5c-0.4 0.4-0.4 1.1 0 1.5s1.1 0.4 1.5 0l8.5-9c0.3-0.3 0.3-0.6 0.3-0.9 0-0.5-0.1-0.9-0.3-1.1z"></path>
  </symbol>
  <symbol id="icon-more" viewBox="0 0 20 20">
    <path d="M12.2 2.2c0 1.215-0.985 2.2-2.2 2.2s-2.2-0.985-2.2-2.2c0-1.215 0.985-2.2 2.2-2.2s2.2 0.985 2.2 2.2z"></path>
    <path d="M12.2 10c0 1.215-0.985 2.2-2.2 2.2s-2.2-0.985-2.2-2.2c0-1.215 0.985-2.2 2.2-2.2s2.2 0.985 2.2 2.2z"></path>
    <path d="M12.2 17.8c0 1.215-0.985 2.2-2.2 2.2s-2.2-0.985-2.2-2.2c0-1.215 0.985-2.2 2.2-2.2s2.2 0.985 2.2 2.2z"></path>
  </symbol>
  <symbol id="icon-setup" viewBox="0 0 20 20">
    <path d="M18.2 10.5v-1l1.5-1.4c0.3-0.3 0.4-0.7 0.2-1l-0.8-2.1c-0.1-0.3-0.5-0.5-0.9-0.6l-2 0.1-0.7-0.7 0.1-2c0-0.4-0.2-0.7-0.6-0.9l-2.1-0.9c-0.1 0-0.2 0-0.4 0s-0.5 0.1-0.7 0.3l-1.4 1.5h-1l-1.3-1.5c-0.1-0.2-0.4-0.3-0.6-0.3s-0.3 0-0.4 0.1l-2.1 0.8c-0.3 0.2-0.6 0.5-0.5 0.9l0.1 2-0.7 0.8-2-0.1c-0.5 0-0.8 0.2-1 0.5l-0.8 2.1c-0.1 0.4-0.1 0.8 0.2 1l1.5 1.4v1l-1.5 1.4c-0.3 0.3-0.4 0.7-0.2 1l0.8 2.1c0.1 0.3 0.5 0.6 0.9 0.6 0 0 0 0 0 0l2-0.1 0.7 0.7-0.1 2c0 0.4 0.2 0.7 0.6 0.9l2.1 0.9c0.1 0 0.2 0 0.4 0 0.3 0 0.5-0.1 0.7-0.3l1.4-1.5h1l1.4 1.5c0.2 0.2 0.4 0.3 0.7 0.3 0.1 0 0.2 0 0.3-0.1l2.1-0.9c0.4-0.1 0.6-0.5 0.6-0.9l-0.1-2 0.7-0.7 2.1 0.1c0.4 0 0.7-0.2 0.8-0.6l0.9-2.1c0.1-0.3 0.1-0.8-0.2-1l-1.7-1.3zM17.5 13.5l-1.3-0.1h-0.9l-1.9 1.9v0.9l0.1 1.3-0.7 0.3-0.8-1-0.6-0.7h-2.8l-0.6 0.7-0.8 0.9-0.7-0.3 0.1-1.3v-0.9l-0.6-0.5-1.3-1.3h-0.9l-1.3 0.1-0.3-0.7 1-0.8 0.7-0.6v-2.8l-0.7-0.6-1-0.8 0.3-0.7 1.3 0.1h0.9l1.9-1.9v-0.9l-0.1-1.3 0.7-0.3 0.8 1 0.6 0.7h2.8l0.6-0.7 0.8-0.9 0.7 0.3-0.1 1.3v0.9l0.6 0.5 1.3 1.3h0.9l1.3-0.1 0.3 0.7-1 0.8-0.7 0.6v2.8l0.7 0.6 0.9 0.8-0.2 0.7z"></path>
    <path d="M10 6.3c-2 0-3.7 1.7-3.7 3.7s1.7 3.7 3.7 3.7c2 0 3.7-1.7 3.7-3.7s-1.7-3.7-3.7-3.7zM10 11.7c-0.9 0-1.7-0.8-1.7-1.7s0.8-1.7 1.7-1.7c0.9 0 1.7 0.8 1.7 1.7s-0.8 1.7-1.7 1.7z"></path>
  </symbol>

</svg>
<router-outlet *ngIf="_isNestedRoute"></router-outlet>
